/// <amd-module name="Test/StackTraceParser/SourceInfoProviderFactory" />
import {
    ISourceInfoProvider,
    ISourceInfoProviderFactoryService,
    RepositoryTypes
} from "Test/StackTraceParser/Contracts";
import { TfsGit } from "Test/StackTraceParser/SourceInfoProviders/TfsGit";
import {
    TfsVersionControl,
} from "Test/StackTraceParser/SourceInfoProviders/TfsVersionControl";
import { IVssComponentContext } from "VSS/Platform/Layout";
import { Services, VssService } from "VSS/Platform/Context";

export class SourceInfoProviderFactoryService extends VssService implements ISourceInfoProviderFactoryService{

    public getSourceInfoProvider(context:IVssComponentContext, repositoryType: string, repository: string, project: string, sourceBranch: string): ISourceInfoProvider {
        repositoryType = repositoryType.toLowerCase();
        if (!SourceInfoProviderFactoryService._sourceProviders[repositoryType]) {
            switch (repositoryType) {
                case RepositoryTypes.TfsGit:
                    SourceInfoProviderFactoryService._sourceProviders[repositoryType] = new TfsGit(context, repository, project, sourceBranch);
                    break;
                case RepositoryTypes.TfsVersionControl:
                    SourceInfoProviderFactoryService._sourceProviders[repositoryType] = new TfsVersionControl(context, project, sourceBranch);
                    break;
                default:
                    break;
            }
        }

        return SourceInfoProviderFactoryService._sourceProviders[repositoryType];
    }

    private static _sourceProviders: { [key: string]: ISourceInfoProvider} = {};
}

Services.add("ISourceInfoProviderFactoryService", {serviceFactory: SourceInfoProviderFactoryService});
